// SPDX-FileCopyrightText: 2021-2025 City of Turku
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import type { CustomizableStaffAttendanceType } from 'lib-customizations/types'

export const additionalStaffAttendanceTypes: CustomizableStaffAttendanceType[] =
  [
    'OTHER_WORK',
    'TRAINING',
    'OVERTIME',
    'JUSTIFIED_CHANGE',
    'SICKNESS',
    'CHILD_SICKNESS'
  ]
